interface LoadingCardsProps { }

const LoadingCards: React.FC<LoadingCardsProps> = () => {
    return (
        <>
            <div className="">
                <div className="h-[400px] flex animate-pulse flex-row items-center justify-center space-x-5">
                    <div className="w-full bg-gray h-[400px] rounded-md "></div>
                </div>
            </div>
            <div className="h-[400px]">
                <div className="h-[400px] flex animate-pulse flex-row items-center  justify-center space-x-5">
                    <div className="w-full bg-gray h-[400px] rounded-md "></div>
                </div>
            </div>
            <div className="h-[400px]">
                <div className="h-[400px] flex animate-pulse flex-row items-center  justify-center space-x-5">
                    <div className="w-full bg-gray h-[400px] rounded-md "></div>
                </div>
            </div>
            <div className="h-[400px]">
                <div className="h-[400px] flex animate-pulse flex-row items-center  justify-center space-x-5">
                    <div className="w-full bg-gray h-[400px] rounded-md "></div>
                </div>
            </div>
        </>
    );
};

export default LoadingCards;